export const CREATE_CATALOG_KEY = 'CREATE_CATALOG_KEY';
export const UPDATE_CATALOG_KEY = 'UPDATE_CATALOG_KEY';
export const DELETE_CATALOG_KEY = 'DELETE_CATALOG_KEY';
export const FETCH_CATALOG_LIST_KEY = 'FETCH_CATALOG_LIST_KEY';
export const FETCH_CATALOG_BY_ID_KEY = 'FETCH_CATALOG_BY_ID_KEY';
export const FETCH_CATALOG_BY_ADMIN = 'FETCH_CATALOG_BY_ADMIN';
export const FETCH_CATALOG_LIST_WITH_NAME_KEY = 'FETCH_CATALOG_LIST_WITH_NAME_KEY';
